module.exports = __webpack_public_path__ + "img/menu.372d47df.svg";